<template>
  <el-dialog
    :title="$t('customerCalibration.Title.calibrationResult')"
    :visible="dialogVisible"
    width="1000px"
    class="customerDialog"
    append-to-body
    @close="dialogCloseHandle"
  >
    <div class="content-body">
      <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('newApp.Customers.CustomerName')" prop="keyword" class="form-item">
              <el-input type="text" v-model.trim="ruleForm.keyword" :placeholder="$t('newApp.Customers.pecn')" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item>
              <el-button @click="resetForm">{{ $t('btn.Reset') }}</el-button>
              <el-button type="primary" @click="submitForm">{{ $t('btn.Search') }}</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-table
        :data="countTableData"
        style="width: 100%"
        border
        class="customer-table"
      >
        <el-table-column :label="$t('customerCalibration.CountList.customerCount')" prop="totalUnitCount" />
        <el-table-column :label="$t('customerCalibration.CountList.crmCustomerCount')" prop="crmUnitCount" />
        <el-table-column :label="$t('customerCalibration.CountList.nonCrmCustomerCount')" prop="nonCrmUnitCount" />
        <el-table-column :label="$t('customerCalibration.CountList.accurateCustomerCount')" prop="accurateUnitCount" />
        <el-table-column :label="$t('customerCalibration.CountList.inaccurateCustomerCount')" prop="inaccurateUnitCount" />
        <el-table-column :label="$t('general.Operation')">
          <template>
            <el-button type="text" size="mini" @click="downloadDetail">{{ $t('customerCalibration.CountList.downloadDetail') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="title">
        <i class="el-icon-warning" />{{ $t('customerCalibration.Info.tip') }}
      </div>
      <el-table
        :data="customerTableData"
        style="width: 100%"
        border
        class="customer-table"
      >
        <el-table-column :label="$t('customerCalibration.CustomerList.customerName')" prop="currentClientName" width="230">
          <template slot-scope="scope">
            <el-input
              v-if="isEditingCell(scope.$index, 'currentClientName')"
              :ref="getEditInputRef(scope.$index, 'currentClientName')"
              v-model.trim="scope.row.currentClientName"
              size="mini"
              @blur="closeCellEdit(scope.row)"
              @keyup.enter.native="closeCellEdit(scope.row)"
            />
            <span
              v-else
              class="editable-cell-text"
              @dblclick="openCellEdit(scope.$index, 'currentClientName')"
            >
              {{ scope.row.currentClientName || '--' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('customerCalibration.CustomerList.isCrmCustomer')" prop="isCrmCustomer">
          <template slot-scope="scope">
            <span>{{ scope.row.isCrmCustomer === 1 ? $t('btn.Yes') : $t('btn.No') }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('customerCalibration.CustomerList.isAccurate')" prop="isNameAccurate">
          <template slot-scope="scope">
            <span>{{ scope.row.isNameAccurate === 1 ? $t('btn.Yes') : $t('btn.No') }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('customerCalibration.CustomerList.crmSuggestedName')" prop="crmSuggestedName">
          <template slot-scope="scope">
            <span v-if="scope.row.isCrmCustomer === 0" @click="handleCRMClick(scope.row)" class="status-text">{{ $t('customerCalibration.CustomerList.clickCalibration') }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('customerCalibration.CustomerList.tycSuggestedName')" prop="tycSuggestedName">
          <template slot-scope="scope">
            <span v-if="scope.row.isTycCustomer === 0" @click="handleTycClick(scope.row)" class="status-text">{{ $t('customerCalibration.CustomerList.clickCalibration') }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wrapper" v-if="customerTotal > 0">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="pageNum"
          :page-size="pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="customerTotal"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogCloseHandle">{{ $t('btn.Cancel') }}</el-button>
      <el-button type="primary" :disabled="submitLoading" v-loading="submitLoading" @click="submitCustomer">{{ $t('btn.OK') }}</el-button>
    </div>
    <el-dialog
      :title="dialogTitle"
      :visible="chooseCustomerDialogVisible"
      width="1000px"
      class="chooseCustomerDialog"
      append-to-body
      @close="chooseCustomerDialogCloseHandle"
    >
      <!-- 建议名称内容 -->
      <div v-if="customerNameList.length > 0">
        <el-radio-group v-model="suggestionName">
          <el-radio v-for="item in customerNameList" :key="item.customerName" :label="item.customerName">{{ item.customerName }}</el-radio>
        </el-radio-group>
      </div>
      <div class="no-data" v-else>
        <span>{{ $t('customerCalibration.Info.noData') }}</span>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="chooseCustomerDialogCloseHandle">{{ $t('btn.Cancel') }}</el-button>
        <el-button type="primary" @click="submitClick" :disabled="chooseLoading" v-loading="chooseLoading">{{ $t('btn.OK') }}</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { isNotEmpty, throttle } from '@/utils/utils';
import { commonApi } from '@/API/common';
import { confirmBusiness } from '@/utils/exportComplianceDialog';
export default {
  data () {
    return {
      ruleForm: {
        keyword: ''
      },
      rules: {
        keyword: [
          { required: false, message: '请输入客户名称', trigger: 'blur' }
        ]
      },
      countTableData: [],
      customerTableData: [],
      pageNum: 1,
      pageSize: 10,
      dialogVisible: false,
      batchId: '',
      suggestionName: '',
      customerNameList: [],
      chooseCustomerDialogVisible: false,
      editingCell: {
        rowIndex: null,
        prop: ''
      },
      clickedRow: {},
      customerTotal: 0,
      dialogTitle: '',
      chooseLoading: false,
      submitLoading: false
    };
  },
  props: {
    exportCustomerVisible: {
      type: Boolean,
      default: false
    },
    calibration: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    exportCustomerVisible: {
      immediate: true,
      handler (val) {
        this.dialogVisible = val;
      }
    },
    calibration: {
      immediate: true,
      handler (val) {
        if (isNotEmpty(val)) {
          this.batchId = val.batchId;
          this.getCustomerData();
        }
      }
    }
  },
  methods: {
    isEditingCell (rowIndex, prop) {
      return this.editingCell.rowIndex === rowIndex && this.editingCell.prop === prop;
    },
    getEditInputRef (rowIndex, prop) {
      return `edit-input-${prop}-${rowIndex}`;
    },
    openCellEdit (rowIndex, prop) {
      this.editingCell = {
        rowIndex,
        prop
      };
      this.$nextTick(() => {
        const inputRef = this.$refs[this.getEditInputRef(rowIndex, prop)];
        const input = Array.isArray(inputRef) ? inputRef[0] : inputRef;
        if (input && typeof input.focus === 'function') {
          input.focus();
        }
      });
    },
    closeCellEdit (row) {
      if (row) {
        this.editingCell = {
          rowIndex: null,
          prop: ''
        };
        if (row.currentClientName) {
          if (row.currentClientName !== row.originalNewClientName) {
            const params = {
              batchId: this.batchId,
              unitId: row.unitId,
              newClientName: row.currentClientName
            };
            commonApi.updateAndRematch(params).then(res => {
              confirmBusiness(this, res, {
                originalBizId: params.batchId || ''
              }).then(passed => {
                if (passed) {
                  this.getCustomerData();
                } else {
                  row.currentClientName = row.originalNewClientName;
                }
              });
            }).catch(() => {
              row.currentClientName = row.originalNewClientName;
            });
          }
        } else {
          row.currentClientName = row.originalNewClientName;
        }
      }
    },
    handleCRMClick (row) {
      this.clickedRow = row;
      this.dialogTitle = this.$t('customerCalibration.Title.crmSuggestedName');
      const params = {
        unitId: row.unitId,
        batchId: this.batchId,
        unitName: row.currentClientName
      };
      // CRM建议名称点击事件
      commonApi.getCrmSuggestions(params).then(res => {
        if (res.status === '200') {
          this.chooseCustomerDialogVisible = true;
          if (isNotEmpty(res.data.suggestions)) {
            this.customerNameList = res.data.suggestions;
          }
        }
      });
    },
    handleTycClick (row) {
      this.clickedRow = row;
      this.dialogTitle = this.$t('customerCalibration.Title.tycSuggestedName');
      const params = {
        unitId: row.unitId,
        batchId: this.batchId,
        unitName: row.currentClientName
      };
      // 天眼查建议名称点击事件
      commonApi.getTycSuggestions(params).then(res => {
        if (res.status === '200') {
          this.chooseCustomerDialogVisible = true;
          if (isNotEmpty(res.data.suggestions)) {
            const list = JSON.parse(JSON.stringify(res.data.suggestions));
            this.customerNameList = list.map(item => {
              return {
                customerName: item
              };
            });
          }
        }
      });
    },
    chooseCustomerDialogCloseHandle () {
      this.suggestionName = '';
      this.clickedRow = {};
      this.customerNameList = [];
      this.chooseCustomerDialogVisible = false;
    },
    submitClick: throttle(function () {
      if (this.customerNameList.length === 0) {
        this.chooseCustomerDialogCloseHandle();
        return;
      } else if (this.suggestionName === '') {
        this.$message.warning(this.$t('general.ps'));
        return;
      }
      const params = {
        batchId: this.batchId,
        unitId: this.clickedRow.unitId,
        newClientName: this.suggestionName
      };
      this.chooseLoading = true;
      commonApi.updateAndRematch(params).then(res => {
        this.chooseLoading = false;
        confirmBusiness(this, res, {
          originalBizId: params.batchId || ''
        }).then(passed => {
          if (passed) {
            this.chooseCustomerDialogCloseHandle();
            this.getCustomerData();
          }
        });
      });
    }, 1000),
    handleCurrentChange (pageNum) {
      this.pageNum = pageNum;
      this.getCustomerData();
    },
    handleSizeChange (pageSize) {
      this.pageSize = pageSize;
      this.pageNum = 1;
      this.getCustomerData();
    },
    getCustomerData () {
      const params = {
        batchId: this.batchId,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        keyword: this.ruleForm.keyword
      };
      // 获取客户数据
      commonApi.getCustomerData(params).then(res => {
        if (res.status === '200') {
          console.log(res.data);
          this.countTableData = [res.data.summary];
          const list = JSON.parse(JSON.stringify(res.data.list));
          list.forEach(item => {
            item.originalNewClientName = item.currentClientName;
          });
          this.customerTableData = list;
          this.getCustomerTotal();
          this.closeCellEdit();
        }
      });
    },
    getCustomerTotal () {
      const params = {
        batchId: this.batchId
      };
      commonApi.confirmCheck(params).then(res => {
        if (res.status === '200') {
          this.customerTotal = res.data > 0 ? res.data : 0;
        }
      });
    },
    submitForm () {
      if (this.ruleForm.keyword !== '') {
        this.getCustomerData();
      }
    },
    resetForm (formName) {
      this.$refs['ruleForm'].resetFields();
      this.ruleForm.keyword = '';
      this.pageNum = 1;
      this.getCustomerData();
    },
    dialogCloseHandle () {
      this.closeCellEdit();
      this.dialogVisible = false;
      this.$emit('update:exportCustomerVisible', false);
      this.$emit('dialogCloseHandle');
    },
    submitCustomer () {
      if (this.customerTotal > 0) {
        this.$confirm(`${this.$t('customerCalibration.Info.warnningStart')}${this.customerTotal}${this.$t('customerCalibration.Info.warnningEnd')}`, this.$t('general.Hint'), {
          confirmButtonText: this.$t('btn.OK'),
          cancelButtonText: this.$t('btn.Modify'),
          type: 'warning'
        }).then(() => {
          this.confirmClick();
        });
      } else {
        this.confirmClick();
      }
    },
    confirmClick: throttle(function () {
      this.submitLoading = true;
      commonApi.confirmBatch({ batchId: this.batchId }).then(res => {
        this.submitLoading = false;
        if (res.status === '200') {
          this.closeCellEdit();
          this.dialogVisible = false;
          this.$emit('update:exportCustomerVisible', false);
          this.$emit('dialogSuccessHandle', res);
        }
      });
    }, 1000),
    downloadDetail () {
      const params = {
        batchId: this.batchId,
        keyword: this.ruleForm.keyword,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      };
      const loading = this.$loading({
        lock: true,
        text: this.$t('general.Loading'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      commonApi.exportBatch(params).then(res => {
        loading.close();
        try {
          const arrayBuffer = res.data;
          const contentDisposition = (res.headers && (res.headers['content-disposition'] || res.headers['Content-Disposition'])) || '';
          let fileName = '客户列表.xlsx';
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename\*=UTF-8''(.+)|filename="?([^";]+)"?/i);
            if (fileNameMatch) {
              fileName = decodeURIComponent(fileNameMatch[1] || fileNameMatch[2]);
            }
          }
          const blob = new Blob([arrayBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            const link = document.createElement('a');
            const url = window.URL.createObjectURL(blob);
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
          }
          this.$message.success(this.$t('general.ExportSuccess'));
        } catch (e) {
          this.$message.error(this.$t('general.ExportFailure'));
        }
      }).catch(() => {
        loading.close();
        this.$message.error(this.$t('general.ExportFailure'));
      });
    }

  },
  mounted () {
  }
};
</script>
<style lang="scss" scoped>
.customerDialog{
  ::v-deep .customer-table {
    border-color: #e2e4e9;

    th.el-table__cell {
      background: #f6f7f9;
      border-color: #e2e4e9;
      color: #424C57;
      font-weight: normal;
    }

    tbody td.el-table__cell {
      border-color: #e2e4e9;
      padding: 7.5px 0;
      color: #424C57;
    }

    th.el-table__cell.is-leaf {
      border-color: #e2e4e9;
    }

    .el-table--border .el-table__cell,
    .el-table__body-wrapper .el-table--border.is-scrolling-left ~ .el-table__fixed {
      border-color: #e2e4e9;
    }

    .el-table__body-wrapper {
      &::-webkit-scrollbar {
        height: 8px;
        width: 8px;
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 5px;
        background: rgba(144, 147, 153, 0.3);
      }

      &::-webkit-scrollbar-thumb:hover {
        background: rgba(144, 147, 153, 0.5);
      }

      &::-webkit-scrollbar-track {
        border-radius: 10px;
        background: #ffffff;
      }
    }

    .el-loading-mask {
      background: rgba(0, 0, 0, 0.2) !important;

      .circular {
        display: none;
      }

      .el-loading-spinner {
        width: 50px;
        height: 50px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        margin-top: 0;

        &:before,
        &:after {
          content: "";
          width: 100%;
          height: 100%;
          border-radius: 50%;
          background-color: #14937b;
          opacity: 0.6;
          position: absolute;
          top: 0;
          left: 0;
          animation: bounce 2.0s infinite ease-in-out;
        }

        &:after {
          animation-delay: -1.0s;
        }
      }

      @keyframes bounce {
        0%, 100% {
          transform: scale(0);
        }

        50% {
          transform: scale(1);
        }
      }
    }
  }
  .title{
    margin: 20px 0;
  }
  .pagination-wrapper {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
  }
  .content-body{
    ::v-deep .el-form .el-form-item__label{
      line-height: 40px !important;
      text-align: left !important;
    }
  }
}
.el-icon-warning{
  color: #E6A23C;
  margin-right: 5px;
}
.no-data{
  text-align: center;
}
.status-text{
  color: #508DB4;
  cursor: pointer;
}
.editable-cell-text {
  display: inline-block;
  width: 100%;
  min-height: 34px;
  line-height: 34px;
  cursor: text;
}
.chooseCustomerDialog{
  ::v-deep .el-radio-group{
    display: flex;
    flex-direction: column;
    .el-radio{
      margin-bottom: 10px;
    }
  }
}
</style>
